import { ComponentListType, IComponentNode } from 'app/app/editor/index.functions';

export function processPageContainersUid(p: any, parentUid: string) {
    if (p.elements) {
        for (let i in p.elements) {
            if (p.elements[i].type == 'container') {
                if (p.elements[i].params.uid != '__mark') {
                    p.elements[i].params.uid = parentUid + '-' + i;
                }
                processPageContainersUid(p.elements[i], parentUid + '-' + i);
            }
        }
    }
}

export function findElementContainerUid(node: IComponentNode, uid: string): string | null {
    let container: string | null = null;
    if (!node.elements) {
        return container;
    }
    node.elements.forEach((e) => {
        if (container != null) {
            return;
        }
        if (e.params.uid == uid) {
            container = node.params.uid;
        } else {
            container = findElementContainerUid(e, uid);
        }
    });
    return container;
}

export function findAllNestedComponentsUid(node: IComponentNode, withContainers: boolean = false): Array<string> {
    let result: Array<string> = [];
    if (withContainers || node.type == 'component') {
        result.push(node.params.uid);
    }
    if (!node.elements) {
        return result;
    }
    node.elements.forEach((e) => {
        if (e.type == 'component') {
            result.push(e.params.uid);
        } else {
            result = result.concat(findAllNestedComponentsUid(e));
        }
    });
    return result;
}

export function generateUid(components: ComponentListType, type: string) {
    const uid = (i: number) => type + (i == 1 ? '' : '-' + i);

    let i = 1;
    while (components[uid(i)]) {
        i++;
    }
    return uid(i);
}
